import { useEffect, useRef } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import ScrollReveal from 'scrollreveal';
import './assets/css/styles.css';

import Footer from './components/Footer';
import Header from './components/Header';

// Home sections
import HomePage from './pages/HomePage';

// Pages
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';

export default function App() {
  const location = useLocation();
  const lastHash = useRef('');

  // ScrollReveal only on Home route
  useEffect(() => {
    if (location.pathname !== '/') return;

    const sr = ScrollReveal({
      distance: '30px',
      duration: 900,
      easing: 'ease',
      origin: 'bottom',
      interval: 120,
      reset: false,
    });

    sr.reveal(
      '.home__data, .specs__content, .specs__img, .how-it-works__step, .faq__item, .download__content',
    );
  }, [location.pathname]);
  const showHeader = location.pathname === '/';
  // Scroll to anchor on hash changes (/#specs, /#faq, ...)
  useEffect(() => {
    if (location.hash) lastHash.current = location.hash.slice(1);

    if (!lastHash.current) return;

    const el = document.getElementById(lastHash.current);
    if (!el) return;

    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      lastHash.current = '';
    }, 0);
  }, [location]);

  return (
    <>
      <style>{`
        .header { height: 120px; }
        .nav { height: 120px; align-items: center; }
        .nav__logo { width: 148px; height: 60px; flex-shrink: 0; }
        .nav__logo img { width: 100%; height: 100%; }

        /* anchor offset for fixed header */
        #home, #specs, #key-features, #how-it-works, #products, #faq, #download {
          scroll-margin-top: 160px;
        }

        /* your horizontal screenshots override */
        .products__container {
          display: flex;
          gap: 2rem;
          overflow-x: auto;
          padding-block: 3rem 2rem;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .products__container::-webkit-scrollbar { display: none; }

        .products__card {
          flex-shrink: 0;
          width: 220px;
          background: none;
          height: auto;
          padding: 0;
          border-radius: 0;
        }
        .phone-mockup {
          background: #111;
          border: 12px solid #000;
          border-radius: 40px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          position: relative;
          overflow: hidden;
        }
        .phone-mockup::before {
          content: '';
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
          width: 70px;
          height: 6px;
          background: #000;
          border-radius: 10px;
          z-index: 2;
        }
        .phone-screen img { width: 100%; height: auto; display: block;opacity:1 }
      `}</style>

      {showHeader && <Header />}

      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/about" element={<AboutPage />} />

        <Route path="/blog" element={<BlogPage />} />

        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
<Route path="/blog/:id" element={<BlogPostPage />} />

        {/* <Route path="*" element={<NotFoundPage />} /> */}
        <Route path="*" element={<HomePage />} />
      </Routes>

      <Footer />
      {/* Scroll Up: Return to the top of the Home */}
      <a href="/#home" className="scrollup" id="scroll-up">
        <i className="ri-arrow-up-s-line scrollup__icon" />
      </a>
    </>
  );
}
